__webpack_require__.p = "/metro/2025/01/new-england-green-book/";